import cookies from 'browser-cookies';
export const setCookie = (cookieName, cookieValue, minutes, path = '/') => {
    const now = new Date();
    const expires = new Date(now.getTime() + minutes * 60 * 1000);
    cookies.set(cookieName, cookieValue, { expires, path });
};
export const getCookie = (cookieName) => {
    return cookies.get(cookieName);
};
export const removeCookie = (cookieName) => {
    cookies.erase(cookieName);
};
